module.exports = __webpack_public_path__ + "static/img/11.b1761ed9.png";